var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"choice",domProps:{"innerHTML":_vm._s(_vm.getLabel())}})
}
var staticRenderFns = []

export { render, staticRenderFns }